define([
    "./monitoringCommonsModule",
    "./monitoringCommonsService",
    "./monitoringCommonsServiceUrls"
], function () {
});